(function () {
  'use strict';

  function initHowToUse(section) {
    var track   = section.querySelector('.ctr-htu__track');
    var dots    = section.querySelectorAll('.ctr-htu__dot');
    var prevBtn = section.querySelector('.ctr-htu__nav-prev');
    var nextBtn = section.querySelector('.ctr-htu__nav-next');
    var cards   = section.querySelectorAll('.ctr-htu__card');

    if (!track || !cards.length) return;

    var total   = cards.length;
    var current = 0;

    /* ── Card step width (card + gap) ── */
    function stepWidth() {
      var card = cards[0];
      if (!card) return track.offsetWidth;
      var gap = parseFloat(getComputedStyle(track).gap) || 12;
      return card.offsetWidth + gap;
    }

    /* ── Go to slide index ── */
    function goTo(index) {
      index = Math.max(0, Math.min(index, total - 1));
      current = index;
      track.scrollTo({ left: stepWidth() * index, behavior: 'smooth' });
      sync();
    }

    /* ── Update dots + button states ── */
    function sync() {
      dots.forEach(function (dot, i) {
        var active = i === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === total - 1;
    }

    /* ── Dot clicks ── */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10));
      });
    });

    /* ── Arrow clicks ── */
    if (prevBtn) {
      prevBtn.addEventListener('click', function () { goTo(current - 1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { goTo(current + 1); });
    }

    /* ── Sync dots to native scroll (swipe / momentum) ── */
    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var step = stepWidth();
        if (step === 0) return;
        var idx = Math.round(track.scrollLeft / step);
        if (idx !== current && idx >= 0 && idx < total) {
          current = idx;
          sync();
        }
      }, 50);
    }, { passive: true });

    /* ── Keyboard: left / right arrows on focused dot ── */
    dots.forEach(function (dot) {
      dot.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      });
    });

    /* ── Initial state ── */
    sync();
  }

  /* ── Boot: find all sections on the page ── */
  function initAll() {
    document.querySelectorAll('.ctr-htu').forEach(initHowToUse);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  /* ── Shopify Theme Editor events ── */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.ctr-htu');
    if (section) initHowToUse(section);
  });
})();
